import React, { useState } from "react";
import AcquisEvalBilan from "./AcquisEvalBilan";
import RecapQuestionsEval from "./RecapQuestionsEval";
import StatutPassationEvalBilan from "../StatutPassatationEvalBilan";
import { ArrowLeft, Users, TrendingUp, Calendar, ClipboardList, ListChecks } from "lucide-react";
import { useClasseContext } from "../../../context/ClasseContext";
import { formatLettresDate } from "../../../utils/ClasseEvaluations";

function DetailEvalBilan ({evalBilan, EvalNat, selectedEvalId, setSelectedEvalId, onReload, setEvalBilan}) {

    const [menu, setMenu] = useState('Statut');
    const {classeNom, groupNom} = useClasseContext();


    const handleBack = () => {
        setSelectedEvalId(false);
    }

    const handleMenuChange = (newMenu) => {
        setMenu(newMenu);
    }

    // Stats rapides
    const totalEleves = evalBilan.eleves_reponses?.length || 0;
    const elevesAvecReponses = evalBilan.eleves_reponses?.filter(e => e.reponses).length || 0;
    const totalQuestions = evalBilan.questions?.length || 0;

    return(
        <div className="px-4 w-full mx-auto">
            <div className="bg-white rounded-2xl 
            sm:rounded-3xl shadow-2xl shadow-blue-200 w-full relative 
            overflow-hidden border border-white/50">
                {/* Header style ListEvalBilan */}
                <div className="relative overflow-hidden">
                    <div className="absolute -inset-2 bg-gradient-to-r from-blue-600 via-cyan-500 to-sky-400 rounded-3xl blur-2xl opacity-30 animate-pulse" />
                    <div className="relative overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-cyan-500 to-sky-400" />
                        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 800 200" preserveAspectRatio="none">
                            <defs>
                                <linearGradient id="header-blob1-detail" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#67e8f9" stopOpacity="0.5" />
                                    <stop offset="100%" stopColor="#a5f3fc" stopOpacity="0.2" />
                                </linearGradient>
                                <linearGradient id="header-blob2-detail" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#a5f3fc" stopOpacity="0.4" />
                                    <stop offset="100%" stopColor="#67e8f9" stopOpacity="0.1" />
                                </linearGradient>
                            </defs>
                            <path fill="url(#header-blob1-detail)">
                                <animate attributeName="d" dur="8s" repeatCount="indefinite"
                                    values="M0,100 Q200,40 400,80 Q600,130 800,70 L800,200 L0,200 Z;
                                            M0,70 Q200,110 400,50 Q600,80 800,120 L800,200 L0,200 Z;
                                            M0,100 Q200,40 400,80 Q600,130 800,70 L800,200 L0,200 Z" />
                            </path>
                            <path fill="url(#header-blob2-detail)">
                                <animate attributeName="d" dur="6s" repeatCount="indefinite"
                                    values="M0,130 Q300,80 500,110 Q700,140 800,90 L800,200 L0,200 Z;
                                            M0,90 Q300,130 500,80 Q700,100 800,140 L800,200 L0,200 Z;
                                            M0,130 Q300,80 500,110 Q700,140 800,90 L800,200 L0,200 Z" />
                            </path>
                            <circle cx="150" cy="80" r="3" fill="white" opacity="0.4">
                                <animate attributeName="cy" dur="3s" values="80;50;80" repeatCount="indefinite" />
                            </circle>
                            <circle cx="650" cy="100" r="2.5" fill="white" opacity="0.3">
                                <animate attributeName="cy" dur="4s" values="100;60;100" repeatCount="indefinite" />
                            </circle>
                            <circle cx="400" cy="70" r="3" fill="white" opacity="0.35">
                                <animate attributeName="cy" dur="3.5s" values="70;40;70" repeatCount="indefinite" />
                            </circle>
                        </svg>
                        <div className="relative px-4 sm:px-6 md:px-8 py-6 sm:py-7 md:py-8">
                            {/* Bouton retour */}
                            <button
                                onClick={handleBack}
                                className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 rounded-xl text-white font-semibold transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg text-sm mb-4"
                            >
                                <ArrowLeft className="w-4 h-4" />
                                Retour aux évaluations
                            </button>

                            <div className="flex justify-center mb-3 sm:mb-4">
                                <div className="p-2 sm:p-3 md:p-4 bg-white/20 backdrop-blur rounded-xl sm:rounded-2xl border border-white/30 shadow-xl">
                                    <ClipboardList className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 text-white" />
                                </div>
                            </div>
                            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-1 sm:mb-2 text-center">
                                {evalBilan.titre}
                            </h1>
                            <div className="flex flex-wrap items-center justify-center gap-4 text-white/80 text-sm sm:text-base mt-2">
                                <span className="flex items-center gap-2">
                                    <Users className="w-4 h-4" />
                                    {classeNom ? 'Classe : ' + classeNom : 'Groupe : ' + groupNom}
                                </span>
                                <span className="flex items-center gap-2">
                                    <Calendar className="w-4 h-4" />
                                    {formatLettresDate(evalBilan.date)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Stats Overview */}
                <div className="px-4 sm:px-6 md:px-8 py-6">
                    <div className="grid grid-cols-3 gap-4">
                        <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-5 border border-blue-100 hover:shadow-md transition-all duration-300 group">
                            <div className="flex items-center gap-3">
                                <div className="p-2.5 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl group-hover:scale-110 transition-transform">
                                    <Users className="w-5 h-5 text-white" />
                                </div>
                                <div>
                                    <div className="text-2xl font-bold text-blue-600">{totalEleves}</div>
                                    <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">Élèves évalués</div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl p-5 border border-emerald-100 hover:shadow-md transition-all duration-300 group">
                            <div className="flex items-center gap-3">
                                <div className="p-2.5 bg-gradient-to-br from-emerald-500 to-green-500 rounded-xl group-hover:scale-110 transition-transform">
                                    <ClipboardList className="w-5 h-5 text-white" />
                                </div>
                                <div>
                                    <div className="text-2xl font-bold text-emerald-600">{elevesAvecReponses} / {totalEleves}</div>
                                    <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">Ont répondu</div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-gradient-to-br from-sky-50 to-blue-50 rounded-2xl p-5 border border-sky-100 hover:shadow-md transition-all duration-300 group">
                            <div className="flex items-center gap-3">
                                <div className="p-2.5 bg-gradient-to-br from-sky-500 to-blue-500 rounded-xl group-hover:scale-110 transition-transform">
                                    <ListChecks className="w-5 h-5 text-white" />
                                </div>
                                <div>
                                    <div className="text-2xl font-bold text-sky-600">{totalQuestions}</div>
                                    <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">Questions</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tabs */}
                <div className="px-4 sm:px-6 md:px-8 pb-2">
                    <div className="flex rounded-xl overflow-hidden border border-gray-200">
                        <button
                            onClick={() => handleMenuChange('Statut')}
                            className={`flex-1 px-4 sm:px-6 py-3 sm:py-4 font-medium transition-all duration-200 text-sm sm:text-base ${
                                menu === 'Statut'
                                    ? 'bg-blue-600 text-white'
                                    : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                            }`}
                        >
                            <div className="flex items-center justify-center gap-2">
                                <Users className="w-4 h-4 sm:w-5 sm:h-5" />
                                <span>État de passation</span>
                            </div>
                        </button>
                        <button
                            onClick={() => handleMenuChange('Progression')}
                            className={`flex-1 px-4 sm:px-6 py-3 sm:py-4 font-medium transition-all duration-200 text-sm sm:text-base ${
                                menu === 'Progression'
                                    ? 'bg-blue-600 text-white'
                                    : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                            }`}
                        >
                            <div className="flex items-center justify-center gap-2">
                                <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5" />
                                <span>Progression vs Éval. Nationale</span>
                            </div>
                        </button>
                        <button
                            onClick={() => handleMenuChange('Questions')}
                            className={`flex-1 px-4 sm:px-6 py-3 sm:py-4 font-medium transition-all duration-200 text-sm sm:text-base ${
                                menu === 'Questions'
                                    ? 'bg-blue-600 text-white'
                                    : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                            }`}
                        >
                            <div className="flex items-center justify-center gap-2">
                                <ListChecks className="w-4 h-4 sm:w-5 sm:h-5" />
                                <span>Résultats par question</span>
                            </div>
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className=" sm:px-6 md:px-8 pb-8">
                    {menu === "Progression" && <AcquisEvalBilan evalBilan={evalBilan} selectedEvalId={selectedEvalId} setSelectedEvalId={setSelectedEvalId} EvalNat={EvalNat} />}
                    {menu === "Statut" && <StatutPassationEvalBilan evalBilan={evalBilan} onReload={onReload} setEvalBilan={setEvalBilan} />}
                    {menu === "Questions" && <RecapQuestionsEval questions={evalBilan.questions} elevesReponses={evalBilan.eleves_reponses} />}
                </div>
            </div>
        </div>
    )
}

export default DetailEvalBilan;
